import {createSlice} from "@reduxjs/toolkit"


export const AuthSlice = createSlice({
    name:'Slice',
    initialState:{
        token:null,
        auth_info:null,
        membershipPlan:{
         childCount:null,
         id:null,
         price:null,
         name:null
        },
        detailEnrolls:null,
        partyBookingDetails:[]
    },
    reducers:{
        credential:(state,action)=>{
            const {generateToken,user} = JSON.parse(action.payload)
            console.log(generateToken)
            state.token = generateToken
            state.auth_info = user
        },
        logout:(state,action)=>{
            state.token = null
        },
        childCount:(state,action)=>{
            state.membershipPlan.childCount = JSON.parse(action.payload)
        },
        members:(state,action)=>{
            const {id,price,name} =  JSON.parse(action.payload)
            state.membershipPlan.id = id
            state.membershipPlan.name = name
            state.membershipPlan.price = price
        },
        detailsEnroll:(state,action)=>{
           state.detailEnrolls = JSON.parse(action.payload)
        },
        partBookingDetails:(state,action)=>{
          const {data,message} = JSON.parse(action.payload)
          switch(message){
            case "dateTime" : 
            const dateTimeList = state.partyBookingDetails.map(el => el?.partyDateTime).filter(dt => dt != null);
            const hasDuplicateDateTime = dateTimeList.length !== new Set(dateTimeList).size;
            const {partytime,partydate} = data
            const dateTime = {partytime,partydate}
            console.log(hasDuplicateDateTime)
            if(!hasDuplicateDateTime){
              state.partyBookingDetails.push({partyDateTime:dateTime})
            }
            console.log(hasDuplicateDateTime)
            break;
            case "package" : 
            const existDateTime = state.partyBookingDetails.map(el => el?.partyPackage).filter(dt => dt != null);
            const hasDuplicatePackage = existDateTime.length !== new Set(existDateTime).size;
            if(!hasDuplicatePackage){
              state.partyBookingDetails.push({partyPackage:data})
            }
            break;
            case "addOn":
            const existAddOn = state.partyBookingDetails.map(el => el?.partAddOn).filter(dt => dt != null);
            const hasDuplicateAddOn = existAddOn.length !== new Set(existAddOn).size;
            if(!hasDuplicateAddOn){
              state.partyBookingDetails.push({partAddOn:data})
            }
            break;
            case "detail":
            const existDetail = state.partyBookingDetails.map(el => el?.partDetail).filter(dt => dt != null);
            const hasDuplicateDetail = existDetail.length !== new Set(existDetail).size;
            if(!hasDuplicateDetail){
              state.partyBookingDetails.push({partDetail:data})
            }
            break;
            case "summary":
            const existSummary = state.partyBookingDetails.map(el => el?.partSummary).filter(dt => dt != null);
            const hasDuplicateSummary = existSummary.length !== new Set(existSummary).size;
            if(!hasDuplicateSummary){
              state.partyBookingDetails.push({partSummary:data})
            }
            break;
          }
        }
    }
})

export const {credential,logout,childCount,members,detailsEnroll,partBookingDetails} = AuthSlice.actions 
export default AuthSlice.reducer